import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./store/userReducer";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage
import { persistStore, persistReducer } from "redux-persist";

const persistConfig = {
  key: "root",
  storage, // Use localStorage to persist data
};

const persistedReducer = persistReducer(persistConfig, userReducer);

export const store = configureStore({
  reducer: {
    user: persistedReducer, // Wrap reducer with persist
  },
});

export const persistor = persistStore(store);
